import { render, staticRenderFns } from "./YourFoodCreate.vue?vue&type=template&id=81debd72&scoped=true&"
import script from "./YourFoodCreate.vue?vue&type=script&lang=js&"
export * from "./YourFoodCreate.vue?vue&type=script&lang=js&"
import style0 from "./YourFoodCreate.vue?vue&type=style&index=0&id=81debd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81debd72",
  null
  
)

export default component.exports